import type { CSSProperties } from 'react';
import greenhouseUrl from '@/assets/svg/colored/Greenhouse.svg';

interface GreenhouseIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSProperties;
}

/**
 * The Greenhouse logo.
 *
 * This was a generated SVG component that inlined a raster image as base64
 * inside the SVG — 72 KB of JavaScript (50.8 KB gzipped) for a logo that every
 * call site draws at 16x16. Three eagerly-reachable modules import it, so it sat
 * in the entry chunk for every visitor. Serving the `.svg` by URL moves those
 * bytes out of the bundle and lets the browser cache the image separately.
 *
 * Kept as a component with the same default export and the same intrinsic
 * dimensions so no call site changes. Every consumer renders it as
 * `<Icon as={Greenhouse} width="16px" height="16px" />`, and Chakra applies that
 * size through `className`, which is why the prop is forwarded — its CSS wins
 * over the attributes below, exactly as it did over the old `<svg>`.
 *
 * Consumers also pass `color`, which is dropped: it only ever tinted
 * `currentColor` fills, and this artwork is a full-colour raster with none.
 *
 * `alt` is empty because the icon sits inside a labelled link (with a tooltip at
 * two of the three call sites), so the accessible name comes from the link.
 */
const GreenhouseIcon = ({
  width = 513,
  height = 512,
  className,
  style,
}: GreenhouseIconProps) => (
  <img
    src={greenhouseUrl}
    alt=""
    width={width}
    height={height}
    className={className}
    style={{ objectFit: 'contain', ...style }}
  />
);

export default GreenhouseIcon;
